export default {
    PORIN_BOX: '@DRAG_PORIN_BOX',
    SKILL: '@DRAG_SKILL'
}
